import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

// Allow the user to input a function.
//
// The user sees something like "(x, a) => a * sin(2 * Math.PI * x)"
//
// value is a string that is a function definition.  It should be
// everything after the '=> ';
// Example: 'a * Math.sin(2 * Math.PI * x)'
//
// onSet is called with the new function
const prefix = '(x, a) => ';

export const FunctionInput = props => {
    const {value, parser, onSet} = props;
    const [userString, setUserString] = useState(value);
    const [errorMsg, setErrorMsg] = useState('');
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    // for when a preset bopped in
    useEffect(() => setUserString(value), [value]);

    // parse the function every time user string changes
    useEffect(() => setErrorMsg(parser(userString)),
              [parser, userString]);

    // user types...
    const changeHandler = e => 
          setUserString(
              e.currentTarget.value.substring(prefix.length));
    
    // send it off
    const clickHandler = e =>
        onSet && onSet(userString);

    // unfocus the button
    const mouseUpHandler = e => 
          buttonRef.current && buttonRef.current.blur();

    return (
        <div>
          <p>
            Waveform Function:
          </p>
          <Input value={prefix + userString}
                 onChange={e => changeHandler(e)}/>
          <br />
          <button onClick={clickHandler}
                  onMouseUp={mouseUpHandler}
                  disabled={!!errorMsg}
                  ref={buttonRef}>
            SET
          </button>
          <ErrorMessage>{errorMsg}</ErrorMessage>
        </div>
    );
};


const Input = styled.textarea`
  width: 650px;
  height: 100px;
  color: #333333;
`;

const ErrorMessage = styled.span`
  color: red;
`;
